import React, {Component} from "react";
import {Redirect} from "react-router-dom";
import SmallDirectionBtn from "../../../Buttons/DirectionBtn";
import BaseBtn from "../../../Buttons/BaseBtn";
import PopupAlert from "../../../Containers/PopupAlert";
import * as Utils from "../../../Utils";
import * as HomeworkService from "../../../../services/Student/HomeworkService";

class Exam extends Component {
    state = {
        // Exam state
        elapsedTime: 0,
        examList: [],
        curIndex: 0,
        link: '',
        isResult: false,
        showStartPopup: false

        // Result state
        // correctList: [],
        // wrongList: [],
        // isPageRedirect: false,
        // url: "",
        // correctNum:0,
        // totalNum:0,
        // showAlertPopup: false,
        // isResultPage: false,
        // isResultVisible: false
    };

    constructor() {
        super();
        this.examIndex = 0;
        this.normalExamCount = 0;
        this.limitTime = 0;
        this.cutline = 0;
        this.accumulativeCutline = 0;
        this.vocabExamResult = {};
        this.audioTimer;
        this.homeworkId = 0;
    }

    componentDidMount = () => {
        this.getHomework();
    }

    componentWillUnmount = () => {
        clearInterval(this.timer);
    }

    timer = () => {
        const {elapsedTime, examList, curIndex} = this.state;
        if (elapsedTime < this.limitTime) {
            this.setState({
                elapsedTime: elapsedTime + 1
            });
        } else {
            this.checkProcess(curIndex, examList.length - 1);
        }
    }

    getHomework = () => {
        HomeworkService.getHomework(Utils.getDate()).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    const categoryList = Utils.setTodayHomework(responseData.data);
                    const donelist = responseData.data.filter((x) => x.subject == "vocabulary" && x.doneDate != null);
                    this.isDone = donelist.length > 0;
                    this.getVocabHomework(Utils.getDate());

                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            alert("SERVER ERROR");
        });
    }

    getVocabHomework = (date) => {
        HomeworkService.getVocabHomework(date).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    //console.log(response.data.data);
                    this.accumnulativeNum = response.data.data.accumnulativeNum;
                    this.hwEndIndex = response.data.data.hwEndIndex;
                    this.accumnulativeExam = (this.accumnulativeNum > 5 && this.accumnulativeNum < this.hwEndIndex);
                    this.grade = response.data.data.grade;
                    this.section = response.data.data.section;
                    this.title = response.data.data.title;
                    this.normalExamCount = response.data.data.vocabulary.length;
                    this.limitTime = response.data.data.limitTime;
                    this.cutline = response.data.data.cutline;
                    this.accumulativeCutline = response.data.data.accumulativeCutline;
                    this.homeworkId = response.data.data.homeworkId;

                    if (this.accumnulativeExam) {
                        this.getAccumulativeVocabHomework();
                    }
                    //console.log(this.cutline);
                    //console.log(this.accumulativeCutline);

                    this.setState({
                        examList: Utils.getVocabExam(response.data.data.vocabulary),
                        showStartPopup: true
                    })

                    this.vocabHomework = response.data;
                    //this.timer = setInterval(this.timer, 1000, 1000);
                }
            } else {
                console.log(response);
                alert('LOGIN ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    getAccumulativeVocabHomework = () => {
        HomeworkService.getAccumulativeVocabHomework(this.grade, this.section, this.title, this.hwEndIndex, this.accumnulativeNum)
            .then((response) => {
                if (response !== null && response.status === 200) {
                    if (response.data !== null && response.data.code === '0000') {
                        this.accumulativeExamList = Utils.getVocabExam(response.data.data);
                    }
                } else {
                    console.log(response);
                    alert('LOGIN ERROR');
                }
            }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    setExamList = (list, id, selectIndex) => {
        const resultList = list.map((item) => (
            <li key={item} onClick={() => this.onAnswerClick(id, item)}>
                <div className={(selectIndex >= 0 && item == list[selectIndex]) ? "exampleBox active" : "exampleBox"}>
                    <span className="example">{item}</span>
                </div>
            </li>)
        );
        return resultList;
    }

    checkProcess = (curIndex, maxIndex) => {
        if (curIndex < maxIndex) {
            this.nextProcess();
            this.stopAudioTimer();
            this.audioTimer = Utils.playSoundafterDelayTime('./sound/buttonClick-stapler.mp3', this.limitTime * 1000);
            //Utils.playSound('./sound/buttonClick-stapler.mp3');
        } else {
            this.onResultButtonClicked();
            // this.setState({ link: '/vocabexamresult' });
        }
    }

    nextProcess = () => {
        let {curIndex, elapsedTime} = this.state;
        const {examList} = this.state;
        let exam = [...examList];
        curIndex = curIndex + 1;
        elapsedTime = (curIndex < examList.length) ? 0 : elapsedTime;

        if (curIndex == examList.length && this.accumnulativeExam && this.examIndex == 0) {
            //console.log(this.accumulativeExamList);
            exam = exam.concat(this.accumulativeExamList);
            this.examIndex++;
        }

        this.setState({
            curIndex: curIndex,
            elapsedTime: elapsedTime,
            examList: exam,
            curExam: exam[curIndex],
        });
    }

    // Button Event
    onNext = () => {
        this.nextProcess();
        Utils.playSound('./sound/buttonClick-stapler.mp3');

        this.stopAudioTimer();
        this.audioTimer = Utils.playSoundafterDelayTime('./sound/buttonClick-stapler.mp3', this.limitTime * 1000);
    }

    onAnswerClick = (id, item) => {
        let {curIndex, examList, elapsedTime} = this.state;
        const selectData = examList[curIndex];
        const selectIndex = Utils.findIndex(selectData.example, item);
        let exam = [...examList];
        exam[curIndex].selectIndex = selectIndex;

        this.setState({
            examList: exam
        });
    }

    // 타이머 텍스트 display
    getTimeInfo = () => {
        const {elapsedTime} = this.state;
        const minute = Math.floor((this.limitTime - elapsedTime) / 60);
        const second = ((this.limitTime - elapsedTime) % 60);
        return `${Utils.twoDigits(minute)}:${Utils.twoDigits(second)}`;
    }

    setNextDirectionButton = () => {
        const {curIndex, examList} = this.state;
        const isNextEnable = (this.accumnulativeExam && (this.examIndex == 0 || (this.examIndex == 1 && curIndex < examList.length - 1))) ||
            (!this.accumnulativeExam && curIndex < examList.length - 1);

        if (isNextEnable && examList[curIndex].selectIndex != -1)
            return (<SmallDirectionBtn btnName="next" click={this.onNext}/>);
        else
            return (<SmallDirectionBtn btnName="next" active="deactive"/>);
    }

    setResultButton = () => {
        const {curIndex, examList} = this.state;
        const isButtonEnable = (this.accumnulativeExam && this.examIndex == 1 && curIndex == examList.length - 1) ||
            (!this.accumnulativeExam && curIndex == examList.length - 1);
        const selectData = examList[curIndex];
        if (isButtonEnable && selectData.selectIndex != -1) {
            return (<BaseBtn btnColor="deepPink" btnName="결과보기" link="#" onClick={this.onResultButtonClicked}/>);
        }
    }

    onResultButtonClicked = () => {
        this.vocabExamResult.result = this.state.examList;
        this.vocabExamResult.isDone = this.isDone;
        this.vocabExamResult.date = Utils.getDate();//this.date;

        clearInterval(this.timer);

        this.setState({isResult: true});
    }

    start = () => {
        this.stopAudioTimer();
        this.audioTimer = Utils.playSoundafterDelayTime('./sound/buttonClick-stapler.mp3', this.limitTime * 1000);
        this.timer = setInterval(this.timer, 1000, 1000);

        this.setState({showStartPopup: false});
    }

    stopAudioTimer = () => {
        Utils.stopSoundTimer();
    }

    render() {
        const categoryName = "vocabulary";
        const {curIndex, examList, link, isPageRedirect, url, showStartPopup} = this.state;

        const exam = examList[curIndex];
        const totaExamlNum = examList.length;

        if (isPageRedirect) {
            return <Redirect to={url}/>
        }

        if (link != '') {
            return <Redirect to={link}/>
        }

        return (
            this.state.isResult ? <Result result={this.vocabExamResult} homeworkId={this.homeworkId}/>
                :
                <div className="contentsWrapper">
                    <h3 className="screenOut">오늘의 {categoryName} 시험</h3>
                    <div className="testWrapper">
                        <dl className={`test ${categoryName}`}>
                            <dt className="title">
                                <div className="titleBox">
                                    <span>{(exam == undefined) ? "" : exam.korean}</span>
                                    <span className="time">
                                    <span className="info">남은 시간</span>
                                    <em className="num">{this.getTimeInfo()}</em>
                                </span>
                                </div>
                            </dt>
                            <dd className="contents">
                                <div className="testBox">
                                    <div className="exampleList">
                                        <ol>
                                            {(exam == undefined) ? "" : this.setExamList(exam.example, exam.id, exam.selectIndex)}
                                        </ol>
                                    </div>
                                </div>
                            </dd>
                        </dl>

                        <div className="numberBox">
                            <div className="countBox">
                                <span className="countTitle">단어</span>
                                <em className="num">
                                    <span
                                        className="currentNum">{curIndex + 1 - this.normalExamCount * this.examIndex}</span>
                                    <span
                                        className="totalNum">{totaExamlNum - this.normalExamCount * this.examIndex}</span>
                                </em>
                            </div>
                        </div>

                        <div className="btnWrapper">
                            <div className="btnDirectionBox">
                                {this.setNextDirectionButton()}
                            </div>
                            <div className="btnSubmitBox">
                                {this.setResultButton()}
                            </div>
                        </div>

                    </div>
                    <PopupAlert active={showStartPopup} message="준비가 됐다면 누르세요~" onConfirm={this.start}/>
                </div>
        );
    }
}

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vocabExamResult: props.result,
            correctList: [],
            wrongList: [],
            isPageRedirect: false,
            url: "",
            correctNum: 0,
            totalNum: 0,
            showAlertPopup: false,
            resultVisible: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const vocabExam = nextProps.result;
        const correctResult = vocabExam.result.filter((x) => x.selectIndex >= 0 && x.example[x.selectIndex] === x.answer);
        const wrongResult = vocabExam.result.filter((x) => x.selectIndex < 0 || x.example[x.selectIndex] !== x.answer);

        let getMakeUpResult = (arr) => {
            const correctList = [];
            for (let i = 0; i < arr.length; i++) {
                correctList.push({
                    id: i + 1,
                    answer: (arr[i].selectIndex >= 0) ? arr[i].example[arr[i].selectIndex] : "시간초과",
                    korean: arr[i].korean
                });
            }
            return correctList;
        }

        const correctList = getMakeUpResult(correctResult);
        const wrongList = getMakeUpResult(wrongResult);

        if (nextProps !== prevState) {
            return {
                isDone: vocabExam.isDone,
                date: vocabExam.date,
                correctList: correctList,
                wrongList: wrongList,
                correctNum: correctList.length,
                totalNum: correctList.length + wrongList.length
            }
        }
    }

    // getVocabExamResult = () => {

    // }

    // setState 설정-> 업데이트-> setResultData 함수 발동 -> 무한루프 오류 해결했으나
    // 점수 낼 때 점수 가져오기가 안되어서 다시 봐야 함

    // setResultData = () => {
    //     // const vocabExam = Utils.getVocabExamResult();
    //     const vocabExam = this.state.vocabExamResult;
    //     console.log(this.state.vocabExamResult);
    //     const correctResult = vocabExam.result.filter((x)=> x.selectIndex >= 0 && x.example[x.selectIndex] === x.answer);
    //     const wrongResult = vocabExam.result.filter((x)=> x.selectIndex < 0 || x.example[x.selectIndex] !== x.answer);

    //     const correctList = this.getMakeUpResult(correctResult);
    //     const wrongList = this.getMakeUpResult(wrongResult);

    //     this.isDone = vocabExam.isDone;
    //     this.date = vocabExam.date;

    //     this.correctList= correctList;
    //     this.wrongList = wrongList;
    //     this.correctNum = correctList.length;
    //     this.totalNum = correctList.length + wrongList.length;

    //     console.log(correctList);
    //     console.log(wrongList);
    // }

    // getMakeUpResult = (arr) => {
    //     const correctList = [];
    //     for(let i=0; i<arr.length; i++){
    //         correctList.push({
    //             id: i+1,
    //             answer: (arr[i].selectIndex >= 0)? arr[i].example[arr[i].selectIndex]:"시간초과",
    //             korean: arr[i].korean
    //         });
    //     }
    //     return correctList;
    // }

    saveVocabReport = () => {
        const {correctNum, totalNum} = this.state;
        const percentage = 100 / totalNum * correctNum;
        if (Utils.isConnectedLocalServer()) {
            this.setState({
                isPageRedirect: true,
                url: "/app/homework"
            });
        } else {
            const report = {
                "homeworkId": this.props.homeworkId,
                "subject": "vocabulary",
                "studentPoint": "",
                "totalExamNum": totalNum,
                "correctNum": correctNum,
                "percentage": percentage,
                "studentVocabPoint": "",
                "description": "",
                "homeworkDueDate": Utils.getDate()
            };

            /*private long homeworkId;
             private String subject;
             private String studentPoint;
             private int totalExamNum;
             private int correctNum;
             private int percentage;
             private Date completedDate;
             private Date hwDueDate;
             private String studentVocabPoint;
             private String description;
             private Date createdDate;
             private Date updatedDate;
             private String createdBy;*/
            // HomeworkService.report(/*Utils.getDate(), correctNum, totalNum, percentage, "vocabulary"*/report).then((response) => {
            HomeworkService.reportVocab(report).then((response) => {
                //console.log(response);
                if (response !== null && response.status === 200) {
                    // 데이터 저장 성공
                    if (response.data !== null && response.data.code === '0000') {
                        //console.log(response.data);
                        this.getTodayHomework(Utils.getDate());
                    } else {
                        alert(response.data.data);
                    }
                } else {
                    console.log(response);
                    alert('LOGIN ERROR');
                }
            }).catch(response => {
                console.log(response);
                alert('SERVER ERROR');
            });
        }
    }

    getTodayHomework = (date) => {
        HomeworkService.getHomework(date).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    //console.log(responseData);
                    const list = responseData.data.filter((x) => x.doneData == null); //남은 숙제 검색
                    this.setState({
                        isPageRedirect: true,
                        url: (list.length === 0) ? "/app/calendar" : "/app/homework"
                    });
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('SERVER ERROR');
            }
        });
    }

    setResultList = (list) => {
        const resultList = list.map((item) => (
            <li key={item.id}>
                <div className="resultBox">
                    <dl>
                        <dt>
                            <span className="answer">
                                <span className="num">{item.id}</span><span className="example">{item.answer}</span>
                            </span>
                        </dt>
                        <dd>
                            <span className="desc">{item.korean}</span>
                        </dd>
                    </dl>
                </div>
            </li>)
        );

        return (
            <div className="answerList">
                <ol>
                    {resultList}
                </ol>
            </div>
        );
    }

    showResult = () => {
        this.setState({
            resultVisible: true
        })
    }

    retry = () => {
        //alert("숙제가 저장되지않습니다. 계속하시겠습니까?");
        this.setState({
            showAlertPopup: true
        });
    }

    confirmPopup = () => {
        this.setState({
            isPageRedirect: true,
            url: "/app/vocabulary",
            showAlertPopup: false,
        })
    }

    setSubmitButton = () => {
        return ((this.isDone) ?
                <div className="btnWrapper">
                    <div className="btnSubmitBox">
                        <BaseBtn btnColor="pink" btnName="다음에 제출하기" btnType="cancel" onClick={this.retry}/>
                    </div>
                </div>
                :
                <div className="btnWrapper">
                    <div className="btnSubmitBox">
                        <BaseBtn btnColor="pink" btnName="다음에 제출하기" btnType="cancel" onClick={this.retry}/>
                        <BaseBtn btnColor="deepPink" btnName="제출하기" btnType="submit" onClick={this.saveVocabReport}/>
                    </div>
                </div>
        );
    }

    render() {
        const categoryName = "vocabulary";
        const {correctList, wrongList, isPageRedirect, url, correctNum, totalNum, showAlertPopup} = this.state;
        const percentage = Math.round(100 / totalNum * correctNum);

        if (isPageRedirect) {
            //console.log(url);
            return <Redirect to={url}/>
        }

        return (
            <div className="contentsWrapper">
                <h3 className="screenOut">오늘의 {categoryName} 시험</h3>
                <div className="testWrapper">
                    <dl className={`test ${categoryName}`}>
                    {/*<dl className={["test", {categoryName}]}>*/}
                        <dt className="title">
                            <div className="titleBox">
                                <span>점수</span>
                                <span className="record">
                                    <em className="current">{(totalNum === 0) ? 0 : percentage}</em>
                                    <span className="total">100</span>
                                    <span className="count">
                                        <span className="current">{correctNum}</span>
                                        <span className="total">{totalNum}</span>
                                        <span className="unit">개</span>
                                    </span>
                                </span>
                            </div>
                        </dt>
                        <dd className="contents">
                            <div className="testBox">
                                {this.state.resultVisible ?
                                    <div className="resultList">
                                        <div className="correct">
                                            <strong>Correct</strong>
                                            {this.setResultList(correctList)}
                                        </div>
                                        <div className="wrong">
                                            <strong>Wrong</strong>
                                            {this.setResultList(wrongList)}
                                        </div>
                                    </div>
                                    : <BaseBtn btnColor="deepPink" btnName="시험결과 상세보기" link="#"
                                               onClick={this.showResult}/>
                                }
                            </div>
                        </dd>
                    </dl>
                    {this.setSubmitButton()}
                </div>

                <PopupAlert active={showAlertPopup} message="숙제가 저장되지않습니다. 계속하시겠습니까?" onConfirm={this.confirmPopup}/>
            </div>
        );
    }
}

export default Exam;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Vocab/Exam.js